import {
  NoticeBoardCreate,
  NoticeBoardList,
  NoticeBoardShow
} from 'pages/communication/notice_boards';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'notice_boards',
  label: 'Mural de avisos',
  list: NoticeBoardList,
  create: NoticeBoardCreate,
  show: NoticeBoardShow,
  actions: ['list', 'create', 'show', 'destroy'],
  parentName: 'communication'
};

export default generateResources(resource);
